import { useState } from "react";
import PropTypes from "prop-types";
import csrfAxios from "@shared/csrfAxios";
import Alert from "@shared/v2/Alert";

const AddBrandedFeatureFlag = ({ brands, features, setBffs }) => {
  const [brandSelection, setBrandSelection] = useState(brands[0].id);

  const [featureSelection, setFeatureSelection] = useState(features[0].id);

  const [errorAdding, setErrorAdding] = useState(false);

  const addBff = () => {
    const params = { brand_id: brandSelection, feature_id: featureSelection };

    csrfAxios
      .post("/support/branded_feature_flags", params)
      .then((response) => {
        setBffs(response.data);
      })
      .catch(() => {
        setErrorAdding(true);
      });
  };

  return (
    <div>
      {errorAdding && (
        <Alert
          variant="error"
          onClose={() => {
            setErrorAdding(false);
          }}
          text="Unable to add Branded Feature Flag."
        />
      )}

      <h4>Add Branded Feature Flag</h4>

      <label htmlFor="select-brand">Brand:</label>

      <select
        id="select-brand"
        onChange={(e) => {
          setBrandSelection(e.target.value);
        }}
      >
        {brands.map((b) => (
          <option key={`brand-option-${b.id}`} value={b.id}>
            {b.name}
          </option>
        ))}
      </select>

      <label htmlFor="select-feature">Feature:</label>

      <select
        id="select-feature"
        onChange={(e) => {
          setFeatureSelection(e.target.value);
        }}
      >
        {features.map((f) => (
          <option value={f.id} key={`feature-option-${f.id}`}>
            {f.name}
          </option>
        ))}
      </select>

      <button type="button" onClick={addBff}>
        Add
      </button>
    </div>
  );
};

AddBrandedFeatureFlag.propTypes = {
  brands: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  features: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  setBffs: PropTypes.func.isRequired,
};

export default AddBrandedFeatureFlag;
